(() => {
    if (!document.getElementById('applicationForm')) {
        return;
    }
    let isMarried = $('#marital_status option:selected')[0].hasAttribute('data-married');
    let spousePanel = $('.spouse.collapse');

    if (isMarried) {
        spousePanel.collapse('show');
    }

    $(document).on('change', '#marital_status', function () {
        let isMarried = $(this).find('option:selected')[0].hasAttribute('data-married');

        if (isMarried) {
            spousePanel.collapse('show');
        }
        else {
            spousePanel.collapse('hide');
        }
    });
})();
